import React from 'react';
import './SidebarRow.css';
import { Avatar, Button } from '@material-ui/core'; 

function SidebarRow({src, Icon, title, className, click}) {
    return (
        <div className="sidebarRow">
            {src && <Button className="ppro" onClick={click}><Avatar src={src} 
            className="pro__ava"
            /> <h4>{title}</h4></Button> }
            {Icon && <Button className={className}><Icon /> <h4>{title}</h4></Button> }
        </div>
    )
}

export default SidebarRow
